import React from 'react';
import PageHeader from '../components/PageHeader';
import CTASection from '../components/CTASection';

const priorities = [
  {
    title: 'Transparent Planning',
    body: 'Post clear public notices on every property under review so neighbors hear about projects before the vote, not after. Livingston County does it — and it works.',
  },
  {
    title: 'Smart Business Growth',
    body: 'Encourage a healthy mix of businesses in Big Flats with an equal playing field for local contractors and bidders.',
  },
  {
    title: 'Hold the Line on Taxes',//UNsur about this
    body: 'No empty promises. The goal is to stop tax growth, watch how every dollar is spent, and look for waste before raising rates.',
  },
  {
    title: 'Safer, Stronger Roads',
    body: 'Truck routes, paving, and recycled materials done right. Decades of working with counties on construction means real expertise.',
  },
  {
    title: 'Protect What Makes Big Flats Special',
    body: 'Low crime, good schools, and a place worth raising a family. Growth shouldn’t come at the cost of the things that brought us here.',
  },
  {
    title: 'Listen to Neighbors',
    body: 'Real engagement — not just at election time. Show up, take notes, do the homework before forming an opinion.',
  },
];

function PrioritiesPage() {
  return (
    <>
      <PageHeader
        eyebrow="Priorities"
        title="What I’ll Work On Day One"
        lead="Ron is running to bring small-business common sense to town hall. Here’s where he’ll start."
      />

      <section className="section">
        <div className="container">
          <div className="priorities__list">
            {priorities.map(p => (
              <div className="priority" key={p.title}>
                <h3>{p.title}</h3>
                <p>{p.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}

export default PrioritiesPage;
